export default __webpack_public_path__ + "static/media/EthanEmerald.aefe8287.svg";